import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { FormProps } from '@/interfaces';
import { INameValue } from '@/interfaces/entities/name-value.interface';
import { defineAsyncComponent } from 'vue';
import FormStepInputs from '../FormStepInputs/FormStepInputs.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageBuilder',
  props: {
    componentDir: {},
    errorComponent: {},
    rendering: {},
    fields: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const vuePagePath = (props.fields?.data as any)?.datasource?.fields?.find(
  (field: INameValue) => field.name == 'vuePagePath'
)?.value;
const vuePageName = (props.fields?.data as any)?.datasource?.fields?.find(
  (field: INameValue) => field.name == 'vuePageName'
)?.value;
const layoutComponent =
  vuePagePath && vuePageName ? defineAsyncComponent(() => import(`@/pages/${vuePagePath}/${vuePageName}.vue`)) : null;

return (_ctx: any,_cache: any) => {
  return (_unref(layoutComponent))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layoutComponent)), _normalizeProps(_guardReactiveProps((_ctx.fields?.data as any)?.datasource)), null, 16))
      ]))
    : (_openBlock(), _createBlock(FormStepInputs, {
        key: 1,
        step: {
      stepName: (_ctx.fields?.data as any)?.datasource?.name,
      formInputs: (_ctx.fields?.data as any)?.datasource?.content,
    }
      }, null, 8, ["step"]))
}
}

})